import { TFunction } from 'i18next'

import { QuoteRelatedDraftInvoiceType } from '../../../enums/quoteRelatedDraftInvoiceType'

interface DeleteQuoteModalContent {
  cancelLabel: string
  description: string
  okLabel: string
  title: string
}

export const getDeleteQuoteModalContent = (
  relatedDraftInvoiceType: QuoteRelatedDraftInvoiceType | undefined,
  t: TFunction,
): DeleteQuoteModalContent => {
  switch (relatedDraftInvoiceType) {
    case QuoteRelatedDraftInvoiceType.DepositInvoice:
      return {
        cancelLabel: t('return'),
        description: t('quotes.delete_quote_modal.with_draft_deposit_invoice.description'),
        okLabel: t('quotes.delete_quote_modal.with_draft_deposit_invoice.delete_quote_and_draft_deposit'),
        title: t('quotes.delete_quote_modal.with_draft_deposit_invoice.title'),
      }
    case QuoteRelatedDraftInvoiceType.Invoice:
      return {
        cancelLabel: t('return'),
        description: t('quotes.delete_quote_modal.with_draft_invoice.description'),
        okLabel: t('quotes.delete_quote_modal.with_draft_invoice.delete_quote_and_draft_invoice'),
        title: t('quotes.delete_quote_modal.with_draft_invoice.title'),
      }
    default:
      return {
        cancelLabel: t('cancel'),
        description: t('quotes.delete_modal.description'),
        okLabel: t('quotes.delete_modal.delete_button'),
        title: t('quotes.delete_modal.title'),
      }
  }
}
